module.exports = __webpack_public_path__ + "static/media/20170620-_DSC071208.0da162d4.jpg";